import { render } from "./ContentBody.vue?vue&type=template&id=6932b980"
import script from "./ContentBody.vue?vue&type=script&lang=js"
export * from "./ContentBody.vue?vue&type=script&lang=js"

import "./ContentBody.vue?vue&type=style&index=0&id=6932b980&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__